import * as React from 'react';
import styled from 'styled-components';
import { ListItemAvatar, ListItemText } from './List';
import { Avatar } from './Avatar';

interface IProps {
  name: string;
  profileImageUrl: string;
}

const OrganizationItem = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export class OrganizationListItem extends React.PureComponent<IProps, {}> {
  public render() {
    const { name, profileImageUrl } = this.props;
    return (
      <OrganizationItem>
        <ListItemAvatar>
          <Avatar src={profileImageUrl} username={name} type={'organization'} />
        </ListItemAvatar>
        <ListItemText>{name}</ListItemText>
      </OrganizationItem>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/OrganizationListItem.tsx